import { render, staticRenderFns } from "./show.vue?vue&type=template&id=19f11215"
import script from "./show.vue?vue&type=script&lang=js"
export * from "./show.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./show.vue?vue&type=custom&index=0&blockType=link&rel=stylesheet&href=%2Fcss%2Fcontent-styles.css"
if (typeof block0 === 'function') block0(component)

export default component.exports